/**
 * OVERRIDE ListingView.jsx
 */

import ListingView from '../../../../components/View/ListingView';

export default ListingView;